import { type TFunction } from 'i18next';

import { today } from 'app/main/components/Utils';

export function getDemsConnectors(sysSettings: any) {
	return [
		{
			name: 'mailchimp',
			icon: 'mailchimp',
			iconPack: 'fa-brands',
			isActive: sysSettings.mailing_mailchimp_integration === 'true'
		},
		{
			name: 'mailup',
			icon: 'logo-mailup-light-small',
			iconPack: 'wise',
			isActive: sysSettings.mailing_mailup_integration === 'true'
		}
	];
}

export default function getDefaultModifiedModelAdd({
	settings,
	sysSettings,
	userData,
	t
}: {
	settings: any;
	sysSettings: any;
	userData: any;
	t: TFunction;
}) {
	if (['wbs_nodes'].includes(settings.modu_title)) {
		return {};
	}

	const baseAddModel: { [x: string]: any } = {
		[`${settings.modu_short}_d_from`]: today().toISOString()
	};

	if (settings.modu_title !== 'people') {
		baseAddModel[
			!userData.user_role_external
				? `${settings.modu_short}_user_assigned_uid`
				: `${settings.modu_short}_user_assigned_2_uid`
		] = userData.user_uid;
	}

	if (settings.modu_title === 'dems') {
		const connectors = getDemsConnectors(sysSettings);
		const activeConnectors = connectors.filter(connector => connector.isActive);
		if (activeConnectors.length === 1) baseAddModel.dems_connector = activeConnectors[0].name;
	} else {
		baseAddModel[`${settings.modu_short}_date`] = today().toISOString();
	}

	if (settings.modu_title === 'orders') {
		baseAddModel.ords_title = t('MODULE_ORDERS_NAME');
		baseAddModel.ords_d_sign = today().toISOString();
		baseAddModel.ords_orst_id = 1;
	}

	if (settings.modu_title === 'activities') {
		baseAddModel.acti_acst_id = 1;
	}

	if (settings.modu_title === 'mails') {
		baseAddModel.mail_dems_enabled = 1;
	}

	if (settings.modu_title === 'invoices') {
		baseAddModel.invc_title = t('MODULE_INVOICES_NAME_SINGULAR').toUpperCase();
		baseAddModel.invc_inst_id = 2;
	}

	return baseAddModel;
}
